module.exports = __webpack_public_path__ + "img/galery-rku10-1-zoom.cc85bcf5.png";